<well-signup-card-layout   [title]="'signup.payment-info' | translate" [icon]="true">
  <i [ngClass]="iconClass" rightIcon></i>

  <div body>
    <well-choose-payment-method
      (save)="onSave($event)"
      [paymentMethodTemplate]="paymentMethodTemplate"
      [showTermsAndConditions]="true">
    </well-choose-payment-method>
  </div>

</well-signup-card-layout>


